'use strict'

/**
 * A default DOMRect object wit zero dimensions as fallback.
 *
 * @type {DOMRect}
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMRect
 */
export const defaultDomRect = {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
    x: 0,
    y: 0
}

/**
 * Returns the absolute position of an element on the page by giving the distance
 * from the element to the page's borders as DOMRect object.
 *
 * Also takes into consideration the element's relative parents and scrolling position.
 *
 *  x/y -->--------------------
 *         |        ^ top     |
 *         |        |         |
 *         |left ------  right|
 *         |<----|elem|------>|
 *         |     ------       |
 *         |        |         |
 *         |        |         |
 *         |        | bottom  |
 *         --------------------
 *
 * @param element
 * @returns {DOMRect}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMRect
 */
export function getElementAbsolutePosition(element) {
    const rect = element.getBoundingClientRect() || defaultDomRect
    const doc = document.documentElement
    const scrollLeft = (window.pageXOffset || doc.scrollLeft || 0) - (doc.clientLeft || 0)
    const scrollTop = (window.pageYOffset || doc.scrollTop || 0) - (doc.clientTop || 0)

    return {
        bottom: document.body.clientHeight - rect.top - scrollTop - rect.height,
        height: rect.height,
        left: rect.left + scrollLeft,
        right: document.body.clientWidth - rect.left - scrollLeft - rect.width,
        top: rect.top + scrollTop,
        width: rect.width,
        x: rect.top + scrollTop,
        y: rect.left + scrollLeft
    }
}
